var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadedLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#F1FFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4292 10.98L17.7092 16.74C17.6653 17.0881 17.4959 17.4082 17.2328 17.6402C16.9696 17.8722 16.6308 18.0001 16.28 18H5.96C5.70539 18 5.46121 17.8989 5.28118 17.7188C5.10114 17.5388 5 17.2946 5 17.04V11.76C5 11.5054 5.10114 11.2612 5.28118 11.0812C5.46121 10.9011 5.70539 10.8 5.96 10.8H8.5436L10.8104 6.2652C10.8503 6.18545 10.9116 6.1184 10.9875 6.07156C11.0634 6.02471 11.1508 5.99994 11.24 6C11.8765 6 12.487 6.25286 12.9371 6.70294C13.3871 7.15303 13.64 7.76348 13.64 8.4V9.36H17C17.2043 9.35993 17.4064 9.40335 17.5926 9.48738C17.7789 9.5714 17.9451 9.69411 18.0803 9.84734C18.2155 10.0006 18.3165 10.1808 18.3767 10.3761C18.4368 10.5714 18.4547 10.7773 18.4292 10.98ZM8.36 11.76H5.96V17.04H8.36V11.76Z",
    fill: "#19BB7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadedLike);
export default __webpack_public_path__ + "static/media/shaded-like.4b4bf6e165ddfd41e6ffb97e2315478f.svg";
export { ForwardRef as ReactComponent };